import Box from '@mui/material/Box'
import { alpha } from '@mui/material/styles'
import React from 'react'

import { SEVERITY_BADGE_SIZE } from './notificationCenterConstants'

const TINT_OPACITY = 0.14

type NotificationBadgeCircleProps = {
  /** Resolved palette colour: the tint is this at low opacity, the icon is it at full. */
  color: string
  size?: number
  children: React.ReactNode
}

const circleSx = (color: string, size: number) => ({
  width: size,
  height: size,
  borderRadius: '50%',
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  bgcolor: alpha(color, TINT_OPACITY),
  color,
})

/** The tinted disc a notification's icon sits in, shared so a pending run and a settled one match. */
const NotificationBadgeCircle = ({ color, size = SEVERITY_BADGE_SIZE, children }: NotificationBadgeCircleProps) => (
  <Box sx={circleSx(color, size)}>{children}</Box>
)

export default NotificationBadgeCircle
